import React, { useEffect } from 'react';
import { parseUrlParams } from 'utils/parseUrlParams';

const AgreementComplete = () => {
  useEffect(() => {
    const params = parseUrlParams(window.location.search);
    window.top.postMessage(
      {
        error: false,
        docuSignComplete: true,
        ...params,
      },
      '*'
    );
  }, []);

  return (
    <div className="transition-item wrapper agreement">
      <h3>Docusign Complete</h3>
    </div>
  );
};

export default AgreementComplete;
